<template>
  <div class="container">
    <div class="text-center">
      <h1 class="display-5">Welcome to Rate Card Manager!</h1>

      <div class="mt-5 w-100 d-flex justify-content-center">
        <button
          class="btn btn-success font-weight-bold btn-lg btnLogin primary-bg-color"
          @click="login"
        >
          Login With Your Arete Account
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  mounted() {
    const config = {
      auth: {
        clientId: process.env.VUE_APP_clientId,
        authority: process.env.VUE_APP_tenant,
        prompt: "select_account",
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
      },
    };
    this.uaa = new Msal.UserAgentApplication(config);
    this.$root.$emit("init");
  },
  props: {},
  methods: {
    acquireToken: function () {
      let that$ = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(","),
      };
      that$.uaa
        .acquireTokenSilent(loginRequest)
        .then(function (tokenResponse) {
          var token = tokenResponse.accessToken;
          that$.$store.commit("login", token);
          that$.$router.push({ name: "home" });
          that$.$store.commit("user", {
            user: tokenResponse.account,
          });
        })
        .catch(function (error) {
          if (error.name === "InteractionRequiredAuthError") {
            return msalnstance
              .acquireTokenPopup(tokenRequest)
              .then(function (tokenResponse) {
                var token = tokenResponse.accessToken;
                that$.$store.commit("login", token);
                that$.$router.push({ name: "home" });
                that$.$store.commit("user", {
                  user: tokenResponse.account,
                });
                that$.$root.$emit("done");
              })
              .catch((err) => {
                that$.$root.$emit("done");
                // handle error
              });
          } else {
            that$.$root.$emit("done");
          }
        });
    },
    login: function (oEvent) {
      var that = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(","),
      };
      this.$root.$emit("progress");
      this.$store.commit("uaa", that.uaa);
      if (this.uaa.getAccount()) {
        this.acquireToken();
      } else {
        this.uaa
          .loginPopup(loginRequest)
          .then((response) => {
            // handle response
            that.acquireToken();
          })
          .catch((err) => {
            // handle error
            that.$root.$emit("done");
          });
      }
    },
  },
  data() {
    return {
      uaa: {},
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btnLogin {
  width: 400px;
  height: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  > div {
    margin-top: 60px;
  }
}
</style>